import { Site } from '../App';
import { useState } from 'react';
import clsx from 'clsx';
import { Link } from '@inertiajs/react';
import { usePage } from '@inertiajs/react';
 
export default function PricingPage({}) {

  return (
    <div className="flex min-h-full flex-1 flex-col justify-center py-12 sm:px-6 lg:px-8 text-gray-900">
        
        <div className="flex flex-col items-center justify-center">
          <img
            className="h-16 w-auto mt-5 -ml-4"
            src="/images/mcloud_logo_dark.png"
            alt="MHub Cloud Logo"
          />
        </div>
        
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="mt-6 text-center text-2xl/9 font-bold tracking-tight text-blue">
            Pricing Overview
          </h2>
        </div>

        <div className="flex flex-col items-center mt-10 ">
          <div className="bg-gradient-to-br from-purple-400 to-blue-500 rounded-xl p-6 shadow-lg text-white mb-6">
            <h3 className="text-xl font-semibold mb-2 text-center">Simple Pricing</h3>
            <p className="text-5xl font-bold text-center mb-2">0.25<span className="text-2xl align-top">€</span></p>
            <p className="text-center text-lg font-medium mb-4">per credit</p>
            <div className="flex justify-center items-center gap-2 mb-2">
              <span className="bg-white text-blue-700 px-3 py-1 rounded-full font-semibold shadow">Minimum: 20 credits</span>
            </div>
            <p className="text-center text-sm opacity-80">Total minimum purchase: <span className="font-bold">5.00€</span></p>
          </div>
          {/* <Link
            href="/buy-credits"
            className="mt-4 w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3 rounded-lg shadow transition duration-150 text-center text-lg"
          >
            Buy Credits
          </Link> */}
        </div>
            
    </div>
  );
}

PricingPage.layout = page => <Site showHeader={false}>{ page }</Site>